import React, { useState, useRef, useEffect } from 'react';
import PersoReport from './tables/PersoReport';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Menubar } from 'primereact/menubar';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { dictionary } from '../../../dictionary';
import EldLogo from '../../../assets/logos/Logo-ELD-02 transparent.png';
const isDevelopment = process.env.NODE_ENV === 'development';
const API_URL = isDevelopment
  ? process.env.REACT_APP_API_URL
  : 'https://eld-timer-backend-service.api.prod.sit.sys.odj.cloud/';

const PersoDialog = (props) => {
  const properties = props.properties;
  const users = properties.eldData[0].users;
  const [disabled, setDisabled] = useState(true);
  const [activeBtn, setActiveBtn] = useState(null);
  const [showCalendar, setShowCalendar] = useState(true);
  const [teamName, setTeamName] = useState(null);
  const [teamToFilter, setTeamToFilter] = useState(null);
  const [date, setDate] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [posts, setPosts] = useState({});
  const [showComponent, setShowComponent] = useState(false);
  const [showNoDataDialog, setShowNoDataDialog] = useState(false);
  const end = <img alt="logo" src={EldLogo} className="mr-2"></img>;
  const teams = [
    { name: 'QC Team', filter: 'qct', buttonIndex: 1 },
    { name: 'Content Team', filter: 'indet', buttonIndex: 2 },
    { name: 'Development Team', filter: 'devt', buttonIndex: 3 },
    { name: 'Localization Team', filter: 'loct', buttonIndex: 4 },
    { name: 'All Teams', filter: 'all', buttonIndex: 5 },
  ];
  const start = (
    <div className="productivity-nav">
      <Button
        icon="pi pi-arrow-circle-left"
        onClick={() => {
          properties.setClient(null);
          properties.setClientChoice(false);
          setDisabled(true);
          setShowCalendar(true);
          setActiveBtn(null);
          setShowComponent(false);
          setTeamToFilter(null);
        }}
      />
      <Button
        className="productivity-export"
        icon="pi pi-file-excel"
        label={dictionary.export_btn}
        onClick={() => {
          properties.onDownload();
          properties.resetStateToInitialValues();
        }}
      />
    </div>
  );

  const userNameToTeamMap = useRef({});
  useEffect(() => {
    userNameToTeamMap.current = users.reduce((acc, user) => {
      acc[user.name] = user.team;
      return acc;
    }, {});
  }, [users]);

  const handleButtonClick = (btnId, teamName, teamFilter) => {
    setActiveBtn(btnId);
    setTeamName(teamName);
    setTeamToFilter(teamFilter);
    setDisabled(false);
  };
  const renderButton = (team, index) => (
    <Button
      key={index}
      label={dictionary[`perso_teams_btn_${team.filter}`]}
      icon="pi pi-table"
      onClick={(e) => {
        handleButtonClick(team.buttonIndex, team.name, team.filter);
      }}
      disabled={activeBtn === team.buttonIndex}
    />
  );
  const handleFetchData = async () => {
    setLoading(true);
    if (!date || !teamToFilter) {
      console.error('Data or team not selected.');
      setLoading(false);
      return;
    }
    const selectedYear = date.getFullYear();
    const selectedMonth = date.getMonth() + 1;

    try {
      const response = await fetch(`${API_URL}posts/perso?year=${selectedYear}&month=${selectedMonth}`, {
        method: 'GET',
        mode: 'cors',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(responseData.message || 'Failed to fetch posts!');
      }
      const allPostsForMonth = responseData[0]?.posts || [];
      let postsToDisplay = [];
      if (teamToFilter === 'all') {
        postsToDisplay = allPostsForMonth;
      } else {
        postsToDisplay = allPostsForMonth.filter((post) => {
          const postUserName = post.user;
          const postUserTeam = userNameToTeamMap.current[postUserName];
          return postUserTeam === teamToFilter;
        });
      }

      setPosts([{ posts: postsToDisplay }]);

      const isEmpty = postsToDisplay.length === 0;
      if (isEmpty) {
        setShowNoDataDialog(true);
      } else {
        setShowNoDataDialog(false);
      }

      setShowCalendar(false);
      setShowComponent(true);
    } catch (error) {
      console.error('Error fetching or processing data:', error);
      setShowNoDataDialog(true);
    } finally {
      setLoading(false);
    }
  };

  const tableprops = {
    posts: posts,
    team: teamName,
    teams: teams,
    date: date,
    users: users,
    setFixRef: properties.setFixRef,
  };

  return (
    <>
      {showNoDataDialog ? (
        <Dialog
          header={dictionary.productivity_teams_no_data}
          visible={showNoDataDialog}
          style={{ width: '25%' }}
          onHide={() => setShowNoDataDialog(false)}
        >
          <p>{dictionary.productivity_teams_no_data_info}</p>
        </Dialog>
      ) : null}
      {showCalendar ? (
        <div className="field-calendar-wrapper">
          <label>{dictionary.export_calendar_year}</label>
          <Calendar
            style={{ width: '100%' }}
            placeholder={dictionary.export_dialog_calendar_placeholder}
            view="month"
            dateFormat="mm/yy"
            value={date}
            onChange={(e) => {
              setDate(e.value);
            }}
            showIcon
          />
          {loading && (
            <div className="loading-wrapper">
              <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="2" animationDuration="3s" />
            </div>
          )}
          <div className="button-wrapper">{teams.map(renderButton)}</div>
          <div className="export-btn-wrapper">
            <Button
              label={dictionary.export_dialog_preview_btn}
              icon="pi pi-eye"
              disabled={disabled}
              onClick={() => {
                handleFetchData();
              }}
            />
          </div>
        </div>
      ) : (
        <div className="productivity-teams-wrapper">
          <Menubar start={start} end={end} />
          {showComponent ? <PersoReport tableprops={tableprops} /> : null}
        </div>
      )}
    </>
  );
};

export default PersoDialog;
